import { PawPrint, Compass, Binoculars, Tent, Bird, Leaf, Trees, Camera, ArrowRight } from "lucide-react";
import { EXPERIENCES } from "../data/content";
import { FadeUp, SectionHead, Img } from "./Reveal";
import { scrollToId } from "./Navbar";

const ICONS = {
  paw: PawPrint,
  compass: Compass,
  binoculars: Binoculars,
  tent: Tent,
  bird: Bird,
  leaf: Leaf,
  trees: Trees,
  camera: Camera,
};

export const Wildlife = () => (
  <section id="wildlife" data-testid="wildlife-section" className="relative py-24 lg:py-36 bg-forest-900/40">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 mb-14">
        <SectionHead
          num="02"
          eyebrow="Wildlife Experiences"
          title="Into the Wild"
          copy="Central India holds the greatest concentration of wild tigers on Earth. This is where we take you — quietly, expertly, unforgettably."
        />
        <FadeUp delay={0.2}>
          <button
            data-testid="explore-wildlife-btn"
            onClick={() => scrollToId("tours")}
            className="group flex items-center gap-3 border border-gold/40 text-gold font-mono text-xs uppercase tracking-[0.22em] px-7 py-4 hover:bg-gold hover:text-forest-950 transition-colors duration-300"
          >
            Explore Wildlife
            <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1.5" />
          </button>
        </FadeUp>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {EXPERIENCES.map((e, i) => {
          const Icon = ICONS[e.icon];
          return (
            <FadeUp key={e.name} delay={(i % 4) * 0.08}>
              <div
                data-testid={`wildlife-card-${e.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="group relative h-64 sm:h-80 overflow-hidden cursor-pointer"
              >
                <Img
                  src={e.img}
                  alt={e.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-950 via-forest-950/30 to-forest-950/10 group-hover:via-forest-950/10 transition-colors duration-500" />
                <div className="absolute inset-0 border border-transparent group-hover:border-gold/40 transition-colors duration-500" />
                <div className="absolute bottom-0 inset-x-0 p-5">
                  <Icon size={18} className="text-gold mb-3" />
                  <h3 className="font-serif text-xl text-cream">{e.name}</h3>
                  <p className="text-xs sm:text-sm text-cream/55 mt-1 leading-snug max-h-0 overflow-hidden group-hover:max-h-20 transition-all duration-500">
                    {e.desc}
                  </p>
                </div>
              </div>
            </FadeUp>
          );
        })}
      </div>
    </div>
  </section>
);
